import { render, staticRenderFns } from "./MessageTable.vue?vue&type=template&id=19898d1c&scoped=true&"
import script from "./MessageTable.vue?vue&type=script&lang=js&"
export * from "./MessageTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageTable.scss?vue&type=style&index=0&id=19898d1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19898d1c",
  null
  
)

export default component.exports